/**
 * Create a DOM element with optional class and attributes
 * @param {string} tag - HTML tag name
 * @param {string} className - CSS class name
 * @param {Object} attributes - Element attributes
 * @returns {HTMLElement} Created element
 */
export function createElement(tag, className = "", attributes = {}) {
  const element = document.createElement(tag)

  if (className) {
    element.className = className
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (key === "innerHTML") {
      element.innerHTML = value
    } else {
      element.setAttribute(key, value)
    }
  })

  return element
}

/**
 * Add multiple event listeners to an element
 * @param {HTMLElement} element - Target element
 * @param {Object} events - Event handlers object
 */
export function addEventListeners(element, events) {
  Object.entries(events).forEach(([event, handler]) => {
    element.addEventListener(event, handler)
  })
}

/**
 * Remove multiple event listeners from an element
 * @param {HTMLElement} element - Target element
 * @param {Object} events - Event handlers object
 */
export function removeEventListeners(element, events) {
  Object.entries(events).forEach(([event, handler]) => {
    element.removeEventListener(event, handler)
  })
}

/**
 * Check if element is visible in viewport
 * @param {HTMLElement} element - Element to check
 * @returns {boolean} Visibility status
 */
export function isElementVisible(element) {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}
